import { createReducer, on } from '@ngrx/store';
import { CartState, initialState } from './cart.state';
import {
  getCartSuccess,
  getCartFailure,
  setSpinner,
  clearMovedToEmptyCartFlag,
  updateCartAll,
  setRefreshCart,
  getCart,
} from './cart.actions';

export const cartReducer = createReducer(
  initialState,
  on(getCart, (state) => ({
    ...state,
    error: null,
  })),

  on(getCartSuccess, (state, { cartDetails }) => ({
    ...state,
    cartDetails,
    cartCount: cartDetails.count,
    cartItems: cartDetails.results || [],
    cartStatus: cartDetails.status,
  })),
  on(getCartFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  on(
    updateCartAll,
    (state, { cartDetails, cartItems, cartCount, cartStatus }) => ({
      ...state,
      ...(cartDetails && { cartDetails }),
      ...(cartItems && { cartItems }),
      ...(cartCount && { cartCount }),
      ...(cartStatus && { cartStatus }),
    }),
  ),
  on(setSpinner, (state, { spinner }) => ({
    ...state,
    spinner,
  })),
  on(clearMovedToEmptyCartFlag, (state) => ({
    ...state,
    movedToEmptyCart: false,
  })),
  on(setRefreshCart, (state, { refreshCart }) => ({
    ...state,
    refreshCart,
  })),
);
